<template>
  <el-col :lg="8" :md="12" :sm="24" class="card">
      <el-card>
        <div class="clearfix" slot="header">
          <app-i18n code="entities.paymentOption.menu"></app-i18n>
          <el-button @click="onClickAdd()" icon="el-icon-fa-plus" type="primary"></el-button>
        </div>
        <div :key="paymentOption.id" v-for="paymentOption in rows" class="category-name">
          <span>Type: {{paymentOption.type}} | Payments: {{paymentOption.numberOfPayments}}</span>
          <div>
            <el-button @click="onClickEdit(paymentOption)" icon="el-icon-fa-edit" type="text" class="btns"></el-button>
            <el-button :disabled="destroyLoading" @click="doDestroyWithConfirm(paymentOption.id)" icon="el-icon-fa-trash" type="text" class="btns" v-if="hasPermissionToDestroy"></el-button>
          </div>
        </div>

        <div class="el-pagination-wrapper">
          <el-pagination
            :current-page="pagination.currentPage || 1"
            :disabled="loading"
            :layout="paginationLayout"
            :total="count"
            @current-change="doChangePaginationCurrentPage"
            @size-change="doChangePaginationPageSize"
          ></el-pagination>
        </div>
      </el-card>

    <el-dialog :visible.sync="dialogFormVisible" :title="titleModal()">
      <!--Form Create Payment Option -->
      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
        v-if="model"
      >
        <el-form-item :label="fields.id.label" :prop="fields.id.name" v-if="isEditing">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input :disabled="true" v-model="model[fields.id.name]"/>
          </el-col>
        </el-form-item>

        <el-form-item 
          :label="fields.type.label"
          :prop="fields.type.name"
          :required="fields.type.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-select placeholder v-model="model[fields.type.name]">
              <el-option :value="undefined">--</el-option>
              <el-option
                :key="option.id"
                :label="option.label"
                :value="option.id"
                v-for="option in fields.type.options"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item 
          :label="fields.status.label"
          :prop="fields.status.name"
          :required="fields.status.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-select placeholder v-model="model[fields.status.name]">
              <el-option :value="undefined">--</el-option>
              <el-option
                :key="option.id"
                :label="option.label"
                :value="option.id"
                v-for="option in fields.status.options"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.numberOfPayments.label"
          :prop="fields.numberOfPayments.name"
          :required="fields.numberOfPayments.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model.number="model[fields.numberOfPayments.name]" ref="focus" ></el-input>
          </el-col>
        </el-form-item>

      </el-form>

      <span class="dialog-footer" slot="footer">
        <el-button @click="dialogFormVisible=false">Cancel</el-button>
        <el-button @click="doSubmit" icon="el-icon-fa-floppy-o" type="primary">
          <app-i18n code="common.save"></app-i18n>
        </el-button>
      </span>
    </el-dialog>
  </el-col>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { PaymentOptionModel } from '@modules/payment-option/payment-option-model';
import { mapGetters, mapActions } from 'vuex';
import { PaymentOptionPermissions } from '@modules/payment-option/payment-option-permissions';
import { i18n } from '@shared/i18n';
import { FormSchema } from '@shared/form/form-schema';

const { fields } = PaymentOptionModel;
const formSchema = new FormSchema([
  fields.id,
  fields.type,
  fields.status,
  fields.numberOfPayments,
]);

export default {
  name: 'app-payment-option-list-card',

  props: ['id'],

  data() {
    return {
      rules: formSchema.rules(),
      model: null,
      dialogFormVisible: false,
    };
  },

  mounted() {
    this.doMountTable(this.$refs.table);
  },

  computed: {
    ...mapGetters({
      rows: 'paymentOption/list/rows',
      count: 'paymentOption/list/count',
      loading: 'paymentOption/list/loading',
      pagination: 'paymentOption/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      destroyLoading: 'paymentOption/destroy/loading',
      paginationLayout: 'layout/paginationLayout',

      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'paymentOption/form/record',
      findLoading: 'paymentOption/form/findLoading',
      saveLoading: 'paymentOption/form/saveLoading',
    }),

    hasPermissionToCreate() {
      return new PaymentOptionPermissions(this.currentUser).create;
    },

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new PaymentOptionPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new PaymentOptionPermissions(this.currentUser).destroy;
    },

    isEditing() {
      return !(this.model.id == null);
    },

    fields() {
      return fields;
    },
  },

  async created() {
    this.model = formSchema.initialValues(this.record);
  },

  methods: {
    ...mapActions({
      doChangeSort: 'paymentOption/list/doChangeSort',
      doChangePaginationCurrentPage:
        'paymentOption/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize:
        'paymentOption/list/doChangePaginationPageSize',
      doMountTable: 'paymentOption/list/doMountTable',
      doDestroy: 'paymentOption/destroy/doDestroy',
      doUpdate: 'paymentOption/form/doUpdate',
      doCreate: 'paymentOption/form/doCreate',
    }),

    async doSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      const { id, ...values } = formSchema.cast(this.model);
      this.dialogFormVisible = false;

      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
        });
      } else {

        return this.doCreate(values);
      }
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy(id);
      } catch (error) {
        //Error
      }
    },

    titleModal() {
      var title = ""
      if (this.isEditing) {
        title = i18n('entities.paymentOption.edit.title')
        return title
      } else {
        title = i18n('entities.paymentOption.new.title')
        return title
      }
    },

    onClickEdit(paymentOption) {
      this.dialogFormVisible = true;
      // Corregido! con el formSchema decides los atributos del modelo que se quieren guardar
      this.model = formSchema.initialValues(paymentOption);
    },
    onClickAdd() {
      this.dialogFormVisible = true;
      this.model = formSchema.initialValues(null);
    },
  },
};
</script>

<style>
.btns {
  padding: 0;
}
</style>
